import NotFound from './not-found';
import Catalog from './catalog';
import { useContext, useState } from 'react';
import { CategoriesContext } from '../../../App';
import { selectImage } from '../../../util/misc';
import MultiLineText from '../../elements/multi-line-text';

enum Tabs {
    Desc,
    Catalog,
}

function OniCatalogWrapper() {
    const { currentCategory } = useContext(CategoriesContext);
    const [tab, setTab] = useState(Tabs.Catalog);
    if (!currentCategory) {
        return <NotFound>Раздел не найден</NotFound>;
    }
    const imgUrl = selectImage(currentCategory.imageVariants, 400, 200, currentCategory.imageUrl);
    return (
        <div className="col-md-9">
            <div className="bx-catalog-tab-section-container">
                <ul className="bx-catalog-tab-list" style={{ marginTop: '0' }}>
                    {currentCategory.description && (
                        <li className={tab === Tabs.Desc ? 'active' : ''} onClick={() => setTab(Tabs.Desc)}>
                            <span>Описание</span>
                        </li>
                    )}
                    <li className={tab === Tabs.Catalog ? 'active' : ''} onClick={() => setTab(Tabs.Catalog)}>
                        <span>Ассортимент</span>
                    </li>
                </ul>
                <div className="bx-catalog-tab-body-container">
                    <div className="bx-catalog-tab-container">
                        <div className={tab !== Tabs.Desc ? 'tab-off hidden' : ''}>
                            <table>
                                <tbody>
                                    <tr>
                                        <td
                                            style={{
                                                width: '125px',
                                                textAlign: 'center',
                                                paddingRight: '20px',
                                            }}
                                        >
                                            <img
                                                src={imgUrl}
                                                alt={currentCategory.name}
                                                style={{ maxWidth: '125px', maxHeight: '125px' }}
                                            />
                                        </td>

                                        <td>
                                            <div style={{ whiteSpace: 'pre-line' }}>
                                                <MultiLineText text={currentCategory.description} />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className={tab !== Tabs.Catalog ? 'tab-off hidden' : ''} style={{ padding: 0 }}>
                            <Catalog />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OniCatalogWrapper;
